import { IAPIRoutes } from "../../../../config";

export type IFacilityRepository = ReturnType<typeof FacilityRepositoryFactory>;

export const FacilityRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, PUT } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getFacilitiesAPI: IGetFacilitiesAPI = async () => {
    try {
      const token = await getAuthenticationToken();

      const response = await GET(
        APIRoutes.apiGetFacilities,
        {},
        {
          Authorization: `Bearer ${token}`,
        }
      );
      return response;
    } catch (error) {
      console.error("Error in getFacilitiesAPI:", error);
      throw error;
    }
  };

  const getAllFacilitiesAPI: IGetFacilitiesAPI = async () => {
    try {
      const response = await GET(APIRoutes.apiGetAllFacilities, {});
      return response;
    } catch (error) {
      console.error("Error in getFacilitiesAPI:", error);
      throw error;
    }
  };

  const assignFacilityAPI: IAssignFacilityAPI = async ({
    userId,
    clinicIds,
  }) => {
    try {
      const token = await getAuthenticationToken();

      const response = await PUT(
        APIRoutes.apiAssignFacility.replace("{userId}", userId),
        { clinic_ids: clinicIds },
        {
          Authorization: `Bearer ${token}`,
        }
      );
      return response;
    } catch (error) {
      console.error("Error in assignFacilityAPI:", error);
      throw error;
    }
  };

  return {
    getFacilitiesAPI,
    assignFacilityAPI,
    getAllFacilitiesAPI,
  };
};
